import React from 'react';
import Plot from 'react-plotly.js';

interface SelfStudyAdminNumberOfLessonsProps {
  data?: any; // 引数として渡すプロパティ
}

// function transformToPlotlyData(sqlData: any[]) {
//   if (!sqlData || sqlData.length === 0) return [];
//   // material_nameごとにユニーク化
//   return Array.from(new Set(sqlData.map((item) => item.material_name)));
// }

function transformToPlotlyData(sqlData: any[]) {
  if (!sqlData || sqlData.length === 0) return [];
  // summary_itemごとにユニーク化
  return Array.from(new Set(sqlData.map((item) => item.summary_item)));
}

export const SelfStudyAdminNumberOfLessons: React.FC<SelfStudyAdminNumberOfLessonsProps> = ({
  data,
}) => {
  // const dataList = data || [];
  // const materialNames = transformToPlotlyData(dataList);

  // const tracesData = materialNames.map((material_name: string, idx: number) => {
  //   // material_nameごとにデータを抽出
  //   const filtered = dataList.filter((item: any) => item.material_name === material_name);
  //   return {
  //     type: 'bar',
  //     x: filtered.map((item: any) => item.label),
  //     y: filtered.map((item: any) => item.material_count),
  //     text: filtered.map((item: any) => item.material_count),
  //     textposition: 'outside',
  //     name: material_name, // ← material_name単位で表示
  //   };
  // });

  const dataList = data || [];
  const summaryItems = transformToPlotlyData(dataList);

  const tracesData = summaryItems.map((summary_item: string, idx: number) => {
    // summary_itemごとにデータを抽出
    const filtered = dataList.filter((item: any) => item.summary_item === summary_item);
    return {
      type: 'bar',
      x: filtered.map((item: any) => item.summary_item),
      y: filtered.map((item: any) => item.count),
      text: filtered.map((item: any) => item.count),
      textposition: 'outside',
      name: summary_item, // ← summary_item単位で表示
    };
  });

  if (dataList.length === 0) return <></>;

  return (
    <>
      <Plot
        data={tracesData}
        layout={{
          title: {
            text: '集計ルール別受講回数',
            font: { size: 24 },
            xref: 'paper',
            x: 0,
          },
          xaxis: {
            // title: {
            //   text: '正答者数', // X軸の単位
            //   font: { size: 10 }, // X軸タイトルのフォントサイズ
            // },
            tickfont: {
              size: 12, // X軸の値のフォントサイズを指定
            },
            tickangle: 0, // X軸のラベルを傾ける
          },
          yaxis: {
            automargin: true, // Y軸のマージンを自動調整
            // tickmode: 'array', // すべての値を表示
            // tickvals: plotlyData.columns[0], // Y軸の値を明示的に指定
            // ticktext: plotlyData.columns[0], // Y軸に表示するテキスト
            tickfont: {
              size: 20, // Y軸の値のフォントサイズを指定
            },
            ticklabelposition: 'inside', // Y軸の文字を左寄せに設定
          },
          margin: {
            t: 40, // 上部のマージンを確保
            l: 20, // 必要最小限の左マージン
            r: 20,
            b: 40,
          },
          autosize: true,
          barmode: 'group',
        }}
        config={{
          responsive: true, // レスポンシブデザインを有効にする
          displayModeBar: false, // モードバーを非表示にする
          displaylogo: false, // Plotlyロゴを非表示にする
          staticPlot: true, // プロットを静的にする
        }}
        style={{ width: '100%', height: '400px' }}
      />
    </>
  );
};
